import { UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { useApiMutation } from 'api/use-api-mutation';
import { TagCreationParameters, Tags, TagsApi, TagType, TagTypeCreateRequest, TagTypesApi } from 'oas';

export const useCreateTag = (): UseMutationResult<Tags, unknown, TagCreationParameters> => {
    const queryClient = useQueryClient();
    return useApiMutation(
        async (attr, apiConfig, axiosInstance) => {
            const res = await new TagsApi(apiConfig, '', axiosInstance).postTag(attr);
            return res.data;
        },
        {
            onSettled: () => {
                queryClient.invalidateQueries({ queryKey: ['tags', 'internal'] });
                queryClient.invalidateQueries({ queryKey: ['tags', 'tag_type'] });
            },
        },
    );
};

export const useCreateTagType = (): UseMutationResult<TagType, unknown, TagTypeCreateRequest> => {
    const queryClient = useQueryClient();
    return useApiMutation(
        async (attr, apiConfig, axiosInstance) => {
            const res = await new TagTypesApi(apiConfig, '', axiosInstance).postTagType(attr);
            return res.data;
        },
        {
            onSettled: () => {
                queryClient.invalidateQueries({ queryKey: ['tags', 'tag_type'] });
            },
        },
    );
};
